export default __webpack_public_path__ + "bfe2998fbd714b234a38294477e6eb40.jpeg";